/* eslint-disable no-constant-condition */
/* eslint-disable @stylistic/no-mixed-operators */
/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @stylistic/max-len */
import React, { Fragment, ReactNode, useState, useEffect } from 'react';
import Popup from 'reactjs-popup';
import { applyPlugin } from 'jspdf-autotable';
import { Container, Row, Col, FormSelect } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';

import jsPDF from 'jspdf';

import SpinningWheel from '../../Parts/SpinningWheel';
import UnlockQuoteModal from './UnlockQuoteModal';
import PlaceOrder from '../OrderModal/PlaceOrder';
import exportQuote from '../../ExcelExport/Export';
import { exportOutdoorOrderForm } from '../../OutdoorShadesExport/Export';
import ForceEditModal from '../ForceEditModal';
import QuoteLevelVariables from './QuoteLevelVariables';
import InvoiceStatus from '../InvoiceStatus';
import BidSpecControl from './BidSpecControl';
import CorradiOnly from './CorradiOnly';
import ShadeImport from '../ShadeImport';
import ApproveOrderButton from './ApproveOrderButton';
import { repriceAssemblies, setAssembliesUnlocked } from '../../Store/entities/assemblies';
import { UseMultipliersByQuoteId, useQuoteIdAndDispatch, useQuoteTypeNameByQuoteId, useQuoteTypes } from '../../Store/entities/quotes/hooks';
import { useAssembliesByQuoteId } from '../../Store/entities/assemblies/hooks';
import apiCalls from '../../PowerShadesAPIFunctions';
import { useIsDealer, useIsPsAdmin, useIsReadOnlyUser } from '../../hooks';
import downloadInstallerCopy from './InstallerCopy';
import { UsePortalDispatch } from '../../Store';
import { useQuoteFabricSamplesByQuoteId } from '../../Store/entities/fabricSamples/hooks';
import { fakeRootType } from '../../FakeRootType';
import { useIsEngineer, useIsService, useUser } from '../../Store/user/hooks';
import updateBidData from '../../Store/entities/quoteBid';
import { useDealers } from '../../Store/entities/hooks';
import { UseUnAcknowledgedWarnings } from './QuoteWarningVerificationsFromStore';
import { useQuoteAccessories } from '../../Store/entities/accessories/hooks';
import { useQuoteAwnings } from '../../Store/entities/awnings/hooks';
import { useErrorsByQuoteId } from '../../Store/entities/assemblies/errors/hooks';
import { loadStatus, QuoteStore } from '../../Store/entities/entitiesType';
import { useCurrentMultiplier } from '../../Store/entities/multipliers/hooks';
import Button from '../../Parts/Button';
import DemoReview from './DemoReviewComponent';
import AdvancedShadeManipulation from './AdvancedShadeManipulation';
import { setQuoteToEditable, setQuoteToUnEditable, wentToQuote } from '../../Store/entities/quotes';
import OrderEmails from '../../Modals/OrderEmails';
import PrintQuoteNew from './PrintQuoteNew';
import SalesApprovalModal from '../../Modals/SalesApprovalModal';
import AwningReleaseButton from './AwningReleaseButton';

applyPlugin(jsPDF);

// Releasing awning orders to KE is manual for now, and limited to these admins.
const AWNING_RELEASE_EMAILS = [
	'jefferson.myers@powershades.com',
	'anthony.schreier@powershades.com',
	'trey.waller@powershades.com',
];

type QuoteActionsInput = {
	quoteId: number;
	ROOT: fakeRootType;
	showEditQuoteDisclaimer: number;
	setShowEditQuoteDisclaimer: (show: number) => void;
	setShowConfigurations: (open: boolean) => void;
};

const QuoteActions = ({ quoteId, ROOT, showEditQuoteDisclaimer, setShowEditQuoteDisclaimer, setShowConfigurations }: QuoteActionsInput) => {
	const quoteFromStore = useQuoteIdAndDispatch(quoteId);
	const quote = React.useMemo(() => quoteFromStore ?? {
		order_status: 'active_quote',
		order_status_index: 0,
		dealer_id: 0,
		distributor_id: 0,
		manufacturer_id: 0,
		representative_id: 0,
		editable: false,
		property_address: {
			company_name: ''
		},
		property_address_id: 0,
		territory_id: 0,
		previous_quote_id: 0,
		notes: '',
	} as unknown as QuoteStore, [quoteFromStore]);

	const location = useLocation();
	const dispatch = UsePortalDispatch();

	const shadeAssemblies = useAssembliesByQuoteId(quoteId);

	useEffect(() => {
		if (!quote?.loadStatus || quote.loadStatus < loadStatus
			.fullyLoaded) {
			return;
		}

		if (quote?.order_status === 'mfg_shipped_order') {
			dispatch(setQuoteToUnEditable(quoteId));
			return;
		}

		const urlParams = new URLSearchParams(location.search);
		const isInitialCreation = urlParams.get('initial') === 'true';
		const forceEdit = urlParams.get('force') === 'true';

		if (
			quote
			&& (isInitialCreation || forceEdit)
			&& quote.order_status === 'active_quote'
		) {
			if (!quote.editable) {
				dispatch(wentToQuote(quoteId));
				dispatch(setQuoteToEditable(quoteId));
			}
		}
	}, [location.search, quote, quote.editable, quote.order_status, quote.loadStatus, quoteId, dispatch]);

	useEffect(() => () => {
		dispatch(setQuoteToUnEditable(quoteId));
	}, [quoteId, dispatch]);

	const quoteAccessoriesState = useQuoteAccessories(quoteId);
	const quoteAwnings = useQuoteAwnings(quoteId);

	const [open, setIsPlacedOrderOpen] = useState(false);

	const { notes } = quote;

	const unsavedConfigurations = UseUnAcknowledgedWarnings(quoteId);
	const [isSalesApprovalOpen, setIsSalesApprovalOpen] = useState(false);

	const userData = useUser();

	const isPsAdmin = useIsPsAdmin();

	const [duplicateLoading, setDuplicateLoading] = useState(false);
	const [duplicateOpen, setDuplicateOpen] = useState(false);
	const [duplicateQuoteType, setDuplicateQuoteType] = useState('');
	const quoteTypesMain = useQuoteTypes();

	const quoteTypesUnfiltered = [
		{
			name: 'Please Select',
			zoho_reference: '',
		},
		...quoteTypesMain,
	];

	const quoteFabricSamplesUnfiltered = useQuoteFabricSamplesByQuoteId(quoteId);
	const quoteFabricSamples = React.useMemo(() => (
		quoteFabricSamplesUnfiltered.filter((s) => s.Quantity > 0)
	), [quoteFabricSamplesUnfiltered]);

	const isDealer = useIsDealer();

	const adds: ReactNode[] = [];

	const installerCopyQuote = { ...quote, shades: shadeAssemblies };

	const hasOutdoorShades = shadeAssemblies.some((a) => a.shade_type_id === 2);

	const isOrder = quote.order_status !== "active_quote";
	const manufacturerId = quote.manufacturer_id ?? 0;

	const isService = useIsService();
	const isEngineer = useIsEngineer();
	const isReadonlyUser = useIsReadOnlyUser();

	const isQuoteStatusBeforeAccountingApproval = quote.order_status === "order_pending_approval" || quote.order_status === "under_review";

	const quoteType = useQuoteTypeNameByQuoteId(quoteId);

	const isAwningQuote = (quote?.product_category ?? 'roller_shades') === 'awnings';

	const showPlaceOrder = () => {
		setIsPlacedOrderOpen(true);
	};

	const [, setTaxModalOpen] = useState(false);

	const closePlaceOrder = () => {
		setTaxModalOpen(false);
		setIsPlacedOrderOpen(false);
	};

	let multiplier = useCurrentMultiplier(quoteId);

	const multipliers = UseMultipliersByQuoteId(quoteId);

	if (multipliers?.list.some((m) => m.name?.toLocaleLowerCase()?.includes("dealer"))
		|| multipliers?.list.find((m) => m.name?.toLocaleLowerCase()?.includes("my price"))) {
		multiplier = multipliers.list.find((m) => m.name?.toLocaleLowerCase()?.includes("dealer"))
			?? multipliers.list.find((m) => m.name?.toLocaleLowerCase()?.includes("my price"))
			?? multiplier;
	}

	const hasDealer = (quote.dealer_id !== null && quote.dealer_id !== undefined && quote.dealer_id !== 0);
	const hasDistributor = (quote.distributor_id !== null && quote.distributor_id !== undefined && quote.distributor_id !== 0);
	const hasRepresentative = (quote.representative_id !== null && quote.representative_id !== undefined && quote.representative_id !== 0);

	const hasEntity = hasDealer || hasDistributor || hasRepresentative;

	const [isInvoiceStatusOpen, setIsInvoiceStatusOpen] = useState(false);
	const [isForceEditModalOpen, setIsForcedEditModelOpen] = useState(false);
	const quoteAccessoriesNeedingUnlocked = quoteAccessoriesState.filter((a) => a.last_time_priced > 0);

	const dealers = useDealers();
	const currentDealer = dealers.find((d) => d.id === quote.dealer_id);
	const { errors: quoteErrors } = useErrorsByQuoteId(quoteId);

	const exportQuoteItem = {
		...quote,
		accessories: quoteAccessoriesState,
		assemblies: shadeAssemblies,
		awnings: quoteAwnings,
	};

	const submit = async () => {
		apiCalls.placeOrderPressed(quoteId).then(() => {
			console.log('placeOrderPressed');
		});

		const hasShadeError = quoteErrors.length > 0;

		// Matches the errored condition PSAwningTableRow uses -- a zeroed awning still in the pricing
		// queue is pending, not broken.
		const hasAwningError = quoteAwnings.some((a) => a.msrp === 0 && !a.is_pricing);

		const hasValidPropertyAddress = quote.property_address !== null && (quote.property_address?.company_name ?? "") !== '';

		const shadesNeedingUnlocked = shadeAssemblies.filter((s) => s.msrp === 0 || s.last_time_priced > (Date.now() / 1000 + (7776000)));

		const isRMAAndHasNoPreviousQuoteId = (quoteType === "Rework" || quoteType === "RMA")
			&& shadeAssemblies.length > 0
			&& !((quote?.previous_quote_id ?? 0) > 0);

		if (hasShadeError) {
			ROOT.alert({
				text: 'Please click Edit Quote and address all shade errors before placing an order.',
				title: 'Shade Errors',
				quoteType,
				icon: 'error',
				oneButton: true,
			})
				.then(() => { })
				.catch(() => { });
		} else if (hasAwningError) {
			ROOT.alert({
				text: 'Please click Edit Quote and address all awning errors before placing an order.',
				title: 'Awning Errors',
				quoteType,
				icon: 'error',
				oneButton: true,
			})
				.then(() => { })
				.catch(() => { });
		} else if (!hasValidPropertyAddress) {
			ROOT.alert({
				text: 'Please enter a valid property address before placing an order.',
				title: 'Missing Property Address',
				quoteType,
				icon: 'error',
				oneButton: true,
			})
				.then(() => { })
				.catch(() => { });
		} else if (unsavedConfigurations.length > 0) {
			ROOT.alert({
				text: 'Please verify the quote configuration.',
				title: 'Quote Configuration Verification',
				noCancelButton: false,
				cancelButtonText: 'Cancel',
				acceptButtonText: 'Show Configuration',
				quoteType,
				icon: 'warning',
				onAccept: () => {
					setShowConfigurations(true);
					console.log('Show Configurations');
				},
			})
				.then(() => { })
				.catch(() => { });
		} else if (
			shadesNeedingUnlocked.length > 0
			|| quoteAccessoriesNeedingUnlocked.length > 0
		) {
			const repriceOldItems = () => {
				quoteAccessoriesNeedingUnlocked.forEach(() => {
				});

				const shadeSeqIds = shadesNeedingUnlocked.map((s) => s.sequence_id);

				dispatch(repriceAssemblies({
					quoteId,
					sequenceIds: shadeSeqIds,
					acc_line_numbers: quoteAccessoriesNeedingUnlocked.map((a) => a.line_number),
				}));

				const shadesNeedingUnlockedSequenceIds = shadesNeedingUnlocked.map((s) => s.sequence_id);
				dispatch(setAssembliesUnlocked({
					quoteId,
					sequenceIds: shadesNeedingUnlockedSequenceIds,
					unlocked: true,
				}));
			};
			ROOT.alert({
				text: 'This quote has expired. Quotes are valid for 90 days. To place this order, please reprice these shades/accessories via the button below.',
				title: 'Old Shade Pricing',
				icon: 'warning',
				cancelButtonText: 'Cancel',
				acceptButtonText: 'Reprice Shades',
				onAccept: repriceOldItems,
			})
				.then(() => { })
				.catch(() => { });
		} else if (quoteFabricSamples.length > 10) {
			ROOT.alert({
				text: 'Please limit fabric samples order quantity to 10 or less.',
				title: 'Fabric Samples Limit',
				quickFormat: 'error',
			})
				.then(() => { })
				.catch(() => { });
		} else if (!quote.territory_id || quote.territory_id === 0) {
			ROOT.alert({
				icon: "error",
				text: "Please enter a valid territory before placing an order.",
				title: "Territory Required",
				quickFormat: "error"

			})
				.then(() => { })
				.catch(() => { });
		} else if (!hasEntity && quoteType !== 'bidspec') {
			ROOT.alert({
				icon: "error",
				text: "Please enter a valid dealer before placing an order.",
				title: "Dealer Required",
				quickFormat: "error"

			})
				.then(() => { })
				.catch(() => { });
		} else if (isRMAAndHasNoPreviousQuoteId) {
			ROOT.alert({
				text: 'Please enter the previous quote id (The PS#) in Advanced Settings to place this RMA/Rework',
				title: 'No Previous Quote Id',
				quickFormat: 'error',
			})
				.then(() => { })
				.catch(() => { });
		} else {
			const propertyName = quote?.property_address?.company_name ?? "";

			const addressSnapshot = (
				await apiCalls.getQuoteAddressSnapshot(propertyName ?? "", quote?.dealer_id ?? 0)
			).data.address_snapshot;

			if (addressSnapshot !== null) {
				ROOT.alert({
					title: 'Existing Property Name',
					icon: 'warning',
					text: isDealer ? (
						<span>
							There is already an installation address with the property name & quot;
							{propertyName}
							& quot;.
							<br />
							<br />
							Continuing with this property name will add shades to the existing
							property in the dashboard.
							<span
								style={{
									display: 'block', marginBottom: '10px'
								}}
							/>
						</span>
					) : (
						<span>
							There is already an installation address with the property name & quot;
							{propertyName}
							& quot; for this dealer.
							<br />
							<br />
							Continuing with this property name will add shades to the existing
							property in the dashboard.
							<span
								style={{
									display: 'block', marginBottom: '10px'
								}}
							/>
						</span>
					),
					cancelButtonText: 'Edit Property Name',
					acceptButtonText: 'Continue',
				})
					.then(showPlaceOrder)
					.catch(() => { });
			} else {
				const isBlank = (str) => (!str || (/^\s*$/).test(str));

				if (isBlank(notes)) {
					showPlaceOrder();
				} else {
					ROOT.alert({
						title: 'Place an Order',
						icon: 'warning',
						text: 'Please acknowledge any notes that specify amendments to this order may be subject to price adjustment. We will do our best to accommodate all requests that promote our standard of quality.',
						cancelButtonText: 'Cancel',
						acceptButtonText: 'I understand, thanks!',
					})
						.then(showPlaceOrder)
						.catch(() => { });
				}
			}
		}
	};

	const placeOrderHidden = !!userData.roles.find((r) => r.role_name.includes("quotebuilder"));

	const placeOrderButton = (
		<Button
			fullWidth
			color={quoteType ?? 'green'}
			title="Place Order"
			onClick={submit}
		>
			Place Order
		</Button>
	);

	adds.push(<Popup open={open} key="placeOrderP" onClose={closePlaceOrder} closeOnDocumentClick={false} >
		<PlaceOrder
			key="place-order-component"
			ROOT={ROOT}
			quoteId={quoteId}
			close={closePlaceOrder}
			done={ROOT.refreshContent}
		/>
	</Popup>);

	if (!isOrder && !(quoteType === "demo")) {
		adds.push(<Col key="placeOrder" xl="auto" lg={3} md={3} sm={4} xs={6} className="mt-2 mt-xl-0" hidden={placeOrderHidden} >
			{placeOrderButton}
		</Col>);
	} else if ((quoteType === "demo")) {
		adds.push(<Col key="demo-review" xl="auto" lg={3} md={3} sm={4} xs={6} className="mt-2 mt-xl-0" >
			<DemoReview
				placeOrderButton={placeOrderButton}
				quoteId={quoteId}
			/>
		</Col>);
	}

	if (isQuoteStatusBeforeAccountingApproval && isPsAdmin) {
		adds.push(<ApproveOrderButton
			approveOrderOpen={isSalesApprovalOpen}
			setApproveOrderOpen={setIsSalesApprovalOpen}
			quoteType={quoteType}
			key="approve-order"
			quoteId={quoteId}
			orderStatus={quote.order_status}
		/>);
	}

	// adds.push(<Col key="export-to-excel" xl="auto" lg={3} md={3} sm={4} xs={6} className="mt-2 mt-xl-0" >
	// 	<Button
	// 		title="Export Quote to Excel"
	// 		color={quoteType ?? 'green'}
	// 		fluid
	// 		fullWidth
	// 		onClick={() => exportQuote(quote, shadeAssemblies, multiplier)}
	// 	>
	// 		Export Quote
	// 	</Button>
	// </Col>);

	if (isPsAdmin && hasOutdoorShades) {
		adds.push(<Col key="export-outdoor" xl="auto" lg={3} md={3} sm={4} xs={6} className="mt-2 mt-xl-0" >
			<Button
				title="Export Outdoor Shades"
				color={quoteType ?? 'green'}
				fluid
				fullWidth
				onClick={() => {
					exportOutdoorOrderForm(installerCopyQuote);
				}}
			>
				Export Outdoor Shades
			</Button>
		</Col>);
	}

	adds.push(<Col key="export-to-excel-2" xl="auto" lg={3} md={3} sm={4} xs={6} className="mt-2 mt-xl-0" >
		<Button
			title="Export Quote to Excel"
			color={quoteType ?? 'green'}
			fluid
			fullWidth
			onClick={() => { exportQuote(exportQuoteItem, shadeAssemblies, multiplier); }}
		>
			Export Quote
		</Button>
	</Col>);
	const duplicateFunction = () => {
		if (isPsAdmin) {
			setDuplicateOpen(true);
		} else {
			setDuplicateLoading(true);
			const duplicateQT = duplicateQuoteType === "" ? "CEDIA" : duplicateQuoteType;
			apiCalls.duplicateQuote(
				quoteId,
				duplicateQT
			).then(() => ROOT.loadContent('#Home'));
		}
	};

	const hasShipped = quote.order_status === "mfg_shipped_order";

	const hasOrdered = quote.order_status !== "active_quote";

	const quoteTypes = quoteTypesUnfiltered
		.filter((qt) => {
			if (!hasShipped && qt.zoho_reference === "rma") return false;
			if (!hasOrdered && qt.zoho_reference === "rework") return false;
			return true;
		});

	adds.push(<Fragment key="duplicate-quote-fragment" >
		<Popup
			className="mobile-modal"
			key="duplicatequote-modal"
			open={duplicateOpen}
			closeOnDocumentClick={false}
			onClose={() => {
				setDuplicateOpen(false);
			}}
			contentStyle={{
				minHeight: '30vh',
				overflowX: 'hidden',
			}}
		>
			<Container style={{ minHeight: '30vh' }} className="local-bootstrap" >
				<Row className="mb-4" >
					<Col>
						<h4 className={`text-${quoteType}`}> Select Quote Type </h4>
					</Col>
				</Row>
				<Row >
					<Col>
						<FormSelect
							value={duplicateQuoteType}
							onChange={(e) => {
								setDuplicateQuoteType(e.target.value);
							}}
						>
							{
								quoteTypes.length > 0 ? (
									quoteTypes.map((qt) => (
										<option key={qt.name} value={qt.name} >
											{qt.name}
										</option>
									))
								) : (
									<option key="loading" value="loading" >
										Loading...
									</option>
								)
							}
						</FormSelect>
					</Col>
				</Row>
				<Row className="bottom-row" >
					<Col className="text-start mb-2" >
						<Button
							color="gray"
							onClick={() => {
								setDuplicateOpen(false);
							}}
						>
							Close
						</Button>
					</Col>
					{
						!duplicateLoading ? (
							<Col className="text-end mb-2" >
								<Button
									color={quoteType ?? 'green'}
									disabled={duplicateLoading}
									onClick={() => {
										setDuplicateLoading(true);
										apiCalls.duplicateQuote(
											quoteId,
											duplicateQuoteType
										).then(() => ROOT.loadContent('#Home'));
									}}
								>
									Duplicate
								</Button>
							</Col>
						) : (
							<Col className="mb-2 text-center" >
								<SpinningWheel
									style={{ fontSize: '2em' }}
									className={`text-${quoteType}`}
								/>
							</Col>
						)
					}
				</Row>
			</Container>
		</Popup>
		<Col xl="auto" lg={3} md={3} sm={4} xs={6} className="mt-2 mt-xl-0" >
			<Button
				fullWidth
				disabled={duplicateLoading}
				color={quoteType ?? 'green'}
				title="Duplicate the Current Quote"
				onClick={duplicateFunction}
			>
				{!duplicateLoading ? (
					'Duplicate Quote'
				) : (
					<SpinningWheel
						style={{
							fontSize: '1.5em',
							marginTop: '0.25em',
							marginBottom: '-0.5em',
						}}
						className={`text-${quoteType}`}
					/>
				)}
			</Button>
		</Col>
	</Fragment>);

	if (isPsAdmin && !quote.editable && isOrder && manufacturerId <= 0 && (isEngineer || isService || isQuoteStatusBeforeAccountingApproval)) {
		adds.push(<>
			<Popup
				key="forceEdit"
				open={isForceEditModalOpen}
			>
				<ForceEditModal
					key="force-edit-modal"
					quoteId={quoteId}
					close={() => {
						setIsForcedEditModelOpen(false);
					}}
				/>
			</Popup>
			<Col xl="auto" lg={3} md={3} sm={4} xs={6} className="mt-2 mt-xl-0" >
				<Button
					key="forceEdit"
					color={quoteType ?? 'green'}
					title="Force Unlock Order"
					onClick={() => setIsForcedEditModelOpen(true)}
				>
					Force Edit
				</Button>
			</Col>
		</>);
	}

	const downloadInstallerCopyLocal = () => {
		downloadInstallerCopy(quote, userData, quoteAccessoriesState, shadeAssemblies, quoteAwnings);
	};

	adds.push(<Col key="quote-variables" xl="auto" lg={3} md={3} sm={4} xs={6} className="mt-2 mt-xl-0" >
		<PrintQuoteNew
			key="print-quote"
			quoteId={quoteId}
			hasErrors={quoteErrors.length > 0}
		/>
	</Col>);

	adds.push(<Col
		hidden={!currentDealer || !!(currentDealer?.current_portfolio && currentDealer.current_portfolio.includes("crutchfield"))}
		key="installer-copy"
		xl="auto"
		lg={3}
		md={3}
		sm={4}
		xs={6}
		className="mt-2 mt-xl-0"
	>
		<Button
			fullWidth
			title="Download the Installer Copy"
			color={quoteType ?? 'green'}
			onClick={downloadInstallerCopyLocal}
		>
			Installer Copy
		</Button>
	</Col>);

	if (isOrder && isPsAdmin) {
		adds.push(<>
			<Col xl="auto" lg={3} md={3} sm={4} xs={6} className="mt-2 mt-xl-0" >
				<Button
					color={quoteType ?? 'green'}
					title="Check Invoice Status"
					onClick={() => setIsInvoiceStatusOpen(true)}
				>
					Invoice Status
				</Button>
			</Col>

			<Popup
				key="invoiceStatus"
				modal
				open={isInvoiceStatusOpen}
				onClose={() => setIsInvoiceStatusOpen(false)}

			>
				<InvoiceStatus
					alert={ROOT.alert}
					isPsAdmin={isPsAdmin}
					quoteId={quoteId}
					close={() => {
						setIsInvoiceStatusOpen(false);
					}}
				/>
			</Popup>
		</>);
	}

	if (
		!quote.editable
		&& !isOrder
		&& !isReadonlyUser
		&& (
			isPsAdmin
			|| quoteType === "cedia"
			|| quoteType === "demo"
			|| quoteType === "rework"
			|| quoteType === "window_covering"
		)
	) {
		adds.push(<UnlockQuoteModal
			quoteId={quoteId}
			sequenceId={showEditQuoteDisclaimer}
			clearSequenceId={() => {
				setShowEditQuoteDisclaimer(-1);
			}}
		/>);
	}

	if (
		!quote.editable
		&& (!isOrder || (isOrder && (quote?.manufacturer_id ?? 0) <= 0))
		&& isPsAdmin
		&& false
	) {
		adds.push(<Col key="secret-edit-o.o" xl="auto" lg={3} md={3} sm={4} xs={6} className="mt-2 mt-xl-0" >
			<Button
				color={quoteType ?? 'green'}
				onClick={() => {
				}}
			>
				No Pricing Edit
			</Button>
		</Col>);
	}

	adds.push(<Col key="quote-variables" xl="auto" lg={3} md={3} sm={4} xs={6} className="mt-2 mt-xl-0" >
		<QuoteLevelVariables
			quoteId={quoteId}
			ROOT={ROOT}
		/>
	</Col>);

	if (!isAwningQuote) {
		adds.push(<Col
			hidden={currentDealer && currentDealer?.current_portfolio.includes("crutchfield")}
			key="advancedshademanipulation"
			xl="auto"
			lg={3}
			md={3}
			sm={4}
			xs={6}
			className="mt-2 mt-xl-0"
		>
			<AdvancedShadeManipulation quoteId={quoteId} />
		</Col>);
	}

	if (quoteType === "Bidspec") {
		adds.push(<Col key="bidspec-control" xl="auto" lg={3} md={3} sm={4} xs={6} className="mt-2 mt-xl-0" >
			<BidSpecControl
				quoteColor={quoteType}
				shadeAssemblies={shadeAssemblies}
				setShadeBidData={(bidData) => {
					dispatch(updateBidData(bidData));
				}}
			/>
		</Col>);
	}

	if (isOrder
		&& quote.order_status !== 'mfg_shipped_order'
		&& isPsAdmin) {
		adds.push(<Col key="outdoor-only" xl="auto" lg={3} md={3} sm={4} xs={6} className="mt-2 mt-xl-0" >
			<CorradiOnly QuoteId={quoteId} />
		</Col>);
	}

	if (isPsAdmin && !isOrder) {
		adds.push(<Col key="shade-import" xl="auto" lg={3} md={3} sm={4} xs={6} className="mt-2 mt-xl-0">
			<ShadeImport
				quoteId={quoteId}
			/>
		</Col>);
	}

	if (isPsAdmin) {
		adds.push(<Col key="demo-advanced" xl="auto" lg={3} md={3} sm={4} xs={6} className="mt-2 mt-xl-0">
			<OrderEmails quoteId={quoteId} quoteType={quoteType} />
		</Col>);
	}

	const canReleaseAwningToKE = AWNING_RELEASE_EMAILS
		.includes((userData.email ?? '').trim().toLowerCase());

	// approved_order is what displays as "Ready For Manufacturing" on the quote.
	const isReadyForManufacturing = quote.order_status === "approved_order";

	if (isAwningQuote && isReadyForManufacturing && canReleaseAwningToKE) {
		adds.push(<AwningReleaseButton
			key="awning-release-ke"
			quoteId={quoteId}
			quoteType={quoteType}
		/>);
	}

	if (isPsAdmin && quote.order_status === "awaiting_sales_approval") {
		adds.push(<>
			<Col key="demo-advanced" xl="auto" lg={3} md={3} sm={4} xs={6} className="mt-2 mt-xl-0">
				<Button
					onClick={() => setIsSalesApprovalOpen(true)}
				>
					Sales Approval
				</Button>
			</Col>
			<SalesApprovalModal
				isOpen={isSalesApprovalOpen}
				onClose={() => setIsSalesApprovalOpen(false)}
				quoteId={quoteId}
			/>
		</>);
	}

	return (
		<Container
			className="local-bootstrap mb-2 p-0"
			style={{ maxWidth: "95vw" }}
			fluid
		>
			<Row className="justify-content-end">
				<Col xl="auto" lg={12} >
					<Row>
						{adds.reverse()}
						{' '}
					</Row>
				</Col>
			</Row>
		</Container>
	);
};

export default QuoteActions;
